export enum DOCTOR_ROLE {
  DOCTOR = 'DOCTOR',
  TRAINER = 'TRAINER',
  MATRATZEN_EXPERT = 'MATRATZEN_EXPERT',
}
